(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         *
         */
        .controller('ReLoginController', ['$scope', 'jwtService', 'sharedDataService', '$uibModalInstance', '$rootScope', 'callsService', function ($scope, jwtService, sharedDataService, $uibModalInstance, $rootScope, callsService) {
            var userId = jwtService.payload.sub;
            $scope.$on('reloginModal:success', function () {
                $uibModalInstance.close();
            });
            callsService.openModal();
            $scope.login = function () {

                jwtService.login(userId, $scope.password)
                    .then(function (result) {
                        $rootScope.$broadcast('reloginModal:success');
                        callsService.closeModal();
                        $uibModalInstance.close();
                    })
                    .catch(function (error) {
                        $scope.loginError = true;
                        if (error.data.status == "IncorrectUserNameOrPassword") {
                            $scope.errorMessage = "Incorrect Password";
                        }
                        else {
                            $scope.errorMessage = error.data.status;
                        }
                    });

            };
            $scope.logout = function () {
                jwtService.clear();
                sharedDataService.clearCache();
                callsService.closeModal();
                $uibModalInstance.dismiss('cancel');
            };
        }]);

})(window.angular);